var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-loader',{attrs:{"show":_vm.loading.isloading,"message":_vm.loading.message,"overlay":true}})}
var staticRenderFns = []

export { render, staticRenderFns }